
import React, { createContext, useContext } from 'react';
import AppConfig from './config';

const AppConfigContext = createContext();

export const AppConfigProvider = ({ children }) => {
  return (
    <AppConfigContext.Provider value={AppConfig}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => {
  return useContext(AppConfigContext);
};
